var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { on: { click: _vm.layoutClickEvent } }, [
    _c(
      "p",
      {
        staticClass: "p-l-10 l-h-30 f-w-bold r-t-l-4 r-t-r-4",
        staticStyle: { "background-color": "#d9dde4" },
      },
      [_vm._v("消息接收人列表")]
    ),
    _c(
      "div",
      { staticClass: "c-fix", staticStyle: { "min-height": "300px" } },
      [
        _c("div", { staticClass: "p-relative f-left w-50-p p-t-30" }, [
          _c(
            "p",
            {
              staticClass:
                "p-absolute top-0 left-0 w-100-p p-l-10 l-h-30 f-s-14",
            },
            [
              _c("span", { staticClass: "f-s-18" }, [
                _vm._v(_vm._s(_vm.unreadAccounts.length)),
              ]),
              _vm._v("人未读"),
            ]
          ),
          _c(
            "div",
            { staticClass: "o-auto", staticStyle: { "max-height": "340px" } },
            _vm._l(_vm.unreadMembers, function (member) {
              return _c(
                "div",
                {
                  key: member.account,
                  staticClass:
                    "m-r-5 p-l-10 p-y-5 l-h-20 f-s-12 cursor-pointer",
                },
                [
                  _c(
                    "p",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      member.account.length == 32
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                height: "40px",
                                background: "#653EB3",
                                width: "40px",
                                color: "#fff",
                                "font-size": "12px",
                                "line-height": "40px",
                                "border-radius": "50%",
                                "text-align": "center",
                                transform: "scale(0.7)",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.getShortNickname(member.nick))
                              ),
                            ]
                          )
                        : _vm._e(),
                      member.account.length != 32 && member.nick != "小圆"
                        ? _c("img", {
                            staticStyle: {
                              display: "inline-block",
                              width: "40px",
                              height: "40px",
                              "vertical-align": "middle",
                              transform: "scale(0.7)",
                            },
                            attrs: {
                              src: require("@/assets/images/im/kefu.svg"),
                            },
                          })
                        : _vm._e(),
                      member.account.length != 32 && member.nick == "小圆"
                        ? _c("img", {
                            staticStyle: {
                              display: "inline-block",
                              width: "40px",
                              height: "40px",
                              "vertical-align": "middle",
                              transform: "scale(0.7)",
                            },
                            attrs: {
                              src: require("@/assets/images/im/xiaoyuan.png"),
                            },
                          })
                        : _vm._e(),
                      member.account.length == 32
                        ? _c(
                            "span",
                            {
                              ref: member.account + "usernameRef",
                              refInFor: true,
                              staticClass: "cursor-pointer c-blue",
                              staticStyle: {
                                display: "inline-block",
                                overflow: "hidden",
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  if ($event.target !== $event.currentTarget)
                                    return null
                                  return _vm.getUserinfo(member.account)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  member.nickInTeam
                                    ? member.nickInTeam
                                    : member.nick
                                ) + _vm._s(member.tel ? "-" + member.tel : "")
                              ),
                            ]
                          )
                        : _c(
                            "span",
                            {
                              ref: member.account + "usernameRef",
                              refInFor: true,
                              staticClass: "cursor-pointer c-blue",
                              staticStyle: {
                                display: "inline-block",
                                overflow: "hidden",
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  if ($event.target !== $event.currentTarget)
                                    return null
                                  return _vm.getUserinfo(member.account)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(member.nick) +
                                  _vm._s(
                                    JSON.parse(member.custom)
                                      ? "-" +
                                          JSON.parse(member.custom).stationName
                                      : ""
                                  )
                              ),
                            ]
                          ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "p-relative f-left w-50-p p-t-30" }, [
          _c(
            "p",
            {
              staticClass:
                "p-absolute top-0 left-0 w-100-p p-l-10 l-h-30 f-s-14 c-blue",
            },
            [
              _c("span", { staticClass: "f-s-18" }, [
                _vm._v(_vm._s(_vm.readAccounts.length)),
              ]),
              _vm._v("人已读"),
            ]
          ),
          _c(
            "div",
            { staticClass: "o-auto", staticStyle: { "max-height": "340px" } },
            _vm._l(_vm.readMembers, function (member) {
              return _c(
                "div",
                {
                  key: member.account,
                  staticClass:
                    "m-r-5 p-l-10 p-y-5 l-h-20 f-s-12 cursor-pointer",
                },
                [
                  _c(
                    "p",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                    },
                    [
                      member.account.length == 32
                        ? _c(
                            "span",
                            {
                              staticStyle: {
                                display: "inline-block",
                                height: "40px",
                                background: "#653EB3",
                                width: "40px",
                                color: "#fff",
                                "font-size": "12px",
                                "line-height": "40px",
                                "border-radius": "50%",
                                "text-align": "center",
                                transform: "scale(0.7)",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.getShortNickname(member.nick))
                              ),
                            ]
                          )
                        : _vm._e(),
                      member.account.length != 32 && member.nick != "小圆"
                        ? _c("img", {
                            staticStyle: {
                              display: "inline-block",
                              width: "40px",
                              height: "40px",
                              "vertical-align": "middle",
                              transform: "scale(0.7)",
                            },
                            attrs: {
                              src: require("@/assets/images/im/kefu.svg"),
                            },
                          })
                        : _vm._e(),
                      member.account.length != 32 && member.nick == "小圆"
                        ? _c("img", {
                            staticStyle: {
                              display: "inline-block",
                              width: "40px",
                              height: "40px",
                              "vertical-align": "middle",
                              transform: "scale(0.7)",
                            },
                            attrs: {
                              src: require("@/assets/images/im/xiaoyuan.png"),
                            },
                          })
                        : _vm._e(),
                      member.account.length == 32
                        ? _c(
                            "span",
                            {
                              ref: member.account + "usernameRef",
                              refInFor: true,
                              staticClass: "cursor-pointer c-blue",
                              staticStyle: {
                                display: "inline-block",
                                overflow: "hidden",
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  if ($event.target !== $event.currentTarget)
                                    return null
                                  return _vm.getUserinfo(member.account)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  member.nickInTeam
                                    ? member.nickInTeam
                                    : member.nick
                                ) + _vm._s(member.tel ? "-" + member.tel : "")
                              ),
                            ]
                          )
                        : _c(
                            "span",
                            {
                              ref: member.account + "usernameRef",
                              refInFor: true,
                              staticClass: "cursor-pointer c-blue",
                              staticStyle: {
                                display: "inline-block",
                                overflow: "hidden",
                                "white-space": "nowrap",
                                "text-overflow": "ellipsis",
                              },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  if ($event.target !== $event.currentTarget)
                                    return null
                                  return _vm.getUserinfo(member.account)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(member.nick) +
                                  _vm._s(
                                    JSON.parse(member.custom)
                                      ? "-" +
                                          JSON.parse(member.custom).stationName
                                      : ""
                                  )
                              ),
                            ]
                          ),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }